var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ValueObject } from 'ddd-base';
/**
 * お知らせ一覧
 */
var Notifications = /** @class */ (function (_super) {
    __extends(Notifications, _super);
    function Notifications() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Notifications.prototype, "notifications", {
        // お知らせ一覧
        get: function () {
            var _a;
            return (_a = this.props.notifications) !== null && _a !== void 0 ? _a : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notifications.prototype, "showFiscalYearUpdate", {
        // 年度更新通知を表示するか
        get: function () {
            var _a;
            return (_a = this.props.showFiscalYearUpdate) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notifications.prototype, "notificationIds", {
        // お知らせID一覧
        get: function () {
            return this.notifications.map(function (_a) {
                var id = _a.id;
                return id;
            });
        },
        enumerable: false,
        configurable: true
    });
    // お知らせ一覧を更新
    Notifications.prototype.updateNotifications = function (notifications) {
        return new Notifications(__assign(__assign({}, this.props), { notifications: notifications }));
    };
    // 既読状態を更新
    Notifications.prototype.updateAlreadyRead = function (props) {
        var notifications = this.notifications.map(function (notification) {
            var prop = props.find(function (_a) {
                var notificationId = _a.notificationId;
                return notification.id === notificationId;
            });
            return prop != null ? notification.updateAlreadyRead(prop.alreadyRead) : notification;
        });
        return this.updateNotifications(notifications);
    };
    // お知らせ一覧をソート
    Notifications.prototype.sortNotifications = function () {
        var notifications = this.notifications.sort(function (a, b) {
            if (a.updatedAt < b.updatedAt) {
                return 1;
            }
            if (a.updatedAt > b.updatedAt) {
                return -1;
            }
            return 0;
        });
        return this.updateNotifications(notifications);
    };
    return Notifications;
}(ValueObject));
export { Notifications };
